export const appConst = {
    webApiUrl: process.env.VUE_APP_API_URL,
    webClientUrl: process.env.VUE_APP_CLIENTURL,
    webClientPort: process.env.VUE_APP_CLIENTPORT
};
